import axios from "../utils/axios";

export const sendContactUsEmail = async (data: { name: string, email: string, title: string, category: string, message: string }): Promise<any> => {
    const response = await axios.post('api/contact-us', data);
    return response?.data || null;
}